import * as React from "react";
import { cn } from "../lib";

const headingTextClass =
  "font-['Rubik'] text-[18px] font-[450] tracking-[-0.36px] text text-[#161827]";

const bodyTextClass = "font-['Rubik'] text-[14px] font-[350] text-[#383B56]";

const HeadingText = ({
  className,
  children,
  ...props
}: React.ComponentProps<"h4">) => {
  return (
    <h4 className={cn(headingTextClass, className)} {...props}>
      {children}
    </h4>
  );
};

const BodyText = ({
  className,
  children,
  ...props
}: React.ComponentProps<"p">) => {
  return (
    <p className={cn(bodyTextClass, className)} {...props}>
      {children}
    </p>
  );
};

export { HeadingText, BodyText, headingTextClass, bodyTextClass };
